export default "__VITE_ASSET__3c71b5b1__"